import right from "../../assets/svg/right1.svg";
import support from "../../assets/svg/support-icon.svg";
import notification from "../../assets/svg/notification-icon.svg";
import categories from "../../assets/svg/categories-icon.svg";

import edit from "../../assets/svg/edit.svg";
import logout from "../../assets/svg/logout.svg";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { Image } from "react-bootstrap";
import cameraIcon from "../../assets/svg/camera_add.svg";
import ReportAnIssueModal from "./topbar/report/report-an-issue-modal";
import {
  getbasicDetAPi,
  getOrgListApi,
  updateProfileImageApi,
} from "./topbar/topbar-api";

const AppBar = ({ title, onClick, classNameAppBar }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [profileDetails, SetPofileDetails] = useState({});
  const [orgId, setSelectedOrgId] = useState(null);
  const [org, setSelectedOrg] = useState(null);
  const [orgList, setOrgList] = useState([]);
  const fileInputRefProfile = useRef(null);
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const popupRef = useRef(null);
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const profileUrl = process.env.REACT_APP_ADMIN_API_URL;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFileClick = () => {
    if (fileInputRefProfile.current) fileInputRefProfile.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => updateProfileImage(reader.result);
      reader.readAsDataURL(file);
    } else {
      toast.error("Please select a valid image");
    }
  };

  const updateProfileImage = async (image) => {
    const response = await updateProfileImageApi({ profile_image: image });
    if (response.data?.success === true) {
      profileDetailFetch();
    } else {
      toast.error("Image update failed");
    }
  };

  const profileDetailFetch = async () => {
    const response = await getbasicDetAPi();
    if (response?.success === true) {
      SetPofileDetails(response.user || {});
    } else {
      // toast.error("Profile fetch failed");
    }
  };

  const fetchOrgList = async () => {
    const response = await getOrgListApi();
    if (response?.success === true) {
      const orgs = response.orgs || [];
      setOrgList(orgs);
      if (orgs.length > 0) {
        setSelectedOrgId(orgs[0].id);
        setSelectedOrg(orgs[0]);
      }
    } else {
      // toast.error("Org fetch failed");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie = "mawalog=; path=/; domain=.mawalog.com";
    window.location.href = `${accountsUrl}/login`;
  };

  useEffect(() => {
    profileDetailFetch();
    fetchOrgList();
  }, []);

  return (
    <div className={`${classNameAppBar} bg-white`}>
      <div className="h-full flex items-center justify-between px-3 py-1">
        <div className="flex items-center gap-3">
          {onClick && (
            <img
              src={right}
              alt="Back"
              className="w8 h8 cursor-pointer"
              onClick={onClick}
            />
          )}
          {title && (
            <h1 className="text-2xl font-semibold font-omny pt-3">{title}</h1>
          )}
        </div>

        <div className="flex gap-4 items-center">
          <img
            src={categories}
            alt="menu"
            className="w-4.5 h-4.5 cursor-pointer"
            onClick={() =>
              window.open(accountsUrl, "_blank", "noopener,noreferrer")
            }
          />
          <img
            src={notification}
            alt="report"
            className="w-6 h-6 cursor-pointer"
            onClick={() => setShowComplaintModule(true)}
          />
          <img
            src={support}
            alt="help"
            className="w-6 h-6 cursor-pointer"
            onClick={() => navigate("/help")}
          />

          <div
            onClick={() => {
              const nextOpenState = !open;
              setOpen(nextOpenState);
              if (nextOpenState) {
                profileDetailFetch();
                fetchOrgList();
              }
            }}
            className="w-8 h-8 rounded-full border-3 border-[#A6D2FF] bg-white flex items-center justify-center cursor-pointer"
          >
            <Image
              src={profileDetails.profile_image}
              alt="Profile"
              className="w-4 h-4"
            />
            {open && (
              <div
                ref={popupRef}
                onClick={(e) => e.stopPropagation()}
                className="
absolute top-11 -right-3 mt-3 mr-14 z-[9999]
bg-[#F9FAFB] rounded-xl shadow-lg
p-3
"
              >
                <div className="p-2 text-center">
                  <div className="relative w-20 h-20 mx-auto">
                    <img
                      src={profileDetails?.profile_image}
                      alt="Profile"
                      className="w-full h-full rounded-full object-cover border-3 p-1 border-[#A6D2FF] bg-white flex items-center justify-center cursor-pointer"
                    />

                    <div className="absolute -bottom-0.5 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md cursor-pointer">
                      <img
                        src={cameraIcon}
                        alt="Edit"
                        className="w-4 h-4"
                        onClick={handleFileClick}
                      />
                    </div>
                  </div>
                  <input
                    ref={fileInputRefProfile}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <h4 className="font-semibold font-omny mt-3">
                    Hi, {profileDetails.first_name} {profileDetails.last_name}!
                  </h4>
                  <p className="text-sm text-gray-500 font-omny">
                    {profileDetails.email}
                  </p>
                </div>
                <div className="flex items-center gap-2 rounded-full px-3 py-2.5 border border-gray-200 bg-white mb-2">
                  {orgList[0]?.image && (
                    <Image
                      src={orgList[0].image}
                      className="h-[25px] w-[25px]"
                    />
                  )}
                  <select
                    className="bg-transparent outline-none font-omny font-medium text-[#004BA8]"
                    value={orgId ?? ""}
                    onChange={(e) => {
                      const id = Number(e.target.value);
                      setSelectedOrgId(id);

                      const selected = orgList.find((o) => o.id === id);
                      setSelectedOrg(selected);
                    }}
                  >
                    {orgList.map((org) => (
                      <option key={org.id} value={org.id}>
                        {org.org_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 divide-y divide-gray-200 mb-2 font-omny font-medium">
                  {["View Profile", "Change Password", "Contact Us"].map(
                    (item) => (
                      <div
                        key={item}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
                        onClick={() => {
                          if (item === "View Profile") {
                            window.open(
                              `${accountsUrl}/user-detail`,
                              "_blank",
                              "noopener,noreferrer",
                            );
                          } else if (item === "Change Password") {
                            window.open(
                              `${accountsUrl}/user-detail#change-password`,
                              "_blank",
                              "noopener,noreferrer",
                            );
                          } else if (item === "Contact Us") {
                            window.open(
                              "https://mawalog.com/say-hello/",
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }
                        }}
                      >
                        <span>{item}</span>
                        <span className="text-black text">›</span>
                      </div>
                    ),
                  )}
                </div>

                <div className="flex justify-around items-center mt-2 mb-2 bg-white rounded-full border border-gray-200 overflow-hidden">
                  <button
                    type="button"
                    className="
      flex items-center justify-center gap-2
      px-16 py-2
      font-omny font-semibold
      text-[#172B4D]
      hover:bg-gray-100
      transition
      rounded-l-full
    "
                    onClick={() =>
                      window.open(`${accountsUrl}/user-edit`, "_blank")
                    }
                  >
                    <img src={edit} alt="edit" className="w-4 h-4" />
                    <span>Edit</span>
                  </button>

                  <div className="w-px h-10 bg-gray-300"></div>

                  <button
                    type="button"
                    className="
      flex items-center justify-center gap-2
      px-14 py-2
      font-omny font-semibold
      text-[#FF4444]
      hover:bg-[#FFEBEB]
      hover:border-[#FF4444]
      transition
      rounded-r-full
    "
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    <img src={logout} alt="logout" className="w-4 h-4" />
                    <span>Sign out</span>
                  </button>
                </div>

                <div className="flex items-center justify-center gap-2">
                  <span
                    className="font-omny font-medium text-gray-500 text-xs hover:underline"
                    onClick={() =>
                      window.open(
                        "https://mawalog.com/privacy-policy/",
                        "_blank",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    Privacy Policy
                  </span>

                  <span className="text-gray-400">•</span>

                  <span
                    className="font-omny font-medium text-gray-500 text-xs hover:underline"
                    onClick={() =>
                      window.open(
                        "https://mawalog.com/terms-condition/",
                        "_blank",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    Terms of Service
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showComplaintModule && (
        <ReportAnIssueModal onCancel={() => setShowComplaintModule(false)} />
      )}
    </div>
  );
};

export default AppBar;
